export const getAugmentDetail = (augmentKey, augmentData) => {
  const allAugments = {};
  for (const c of Object.values(augmentData ?? {})) {
    for (const key in c) {
      allAugments[key] = c[key];
    }
  }

  return (
    allAugments?.[
      Object.keys(allAugments)?.find(
        (aug) => aug.toLowerCase() === augmentKey?.toLowerCase(),
      )
    ] || {}
  );
};
